import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/radix/tooltip";
import React from "react";

export const DistanceTooltip = React.memo(function DistanceTooltip({
	distance,
	distanceFromText,
}: {
	distance: number;
	distanceFromText?: string;
}) {
	const displayDistance = React.useMemo(() => {
		return distance < 1000 ? `${distance}m` : `${(distance / 1000).toFixed(1)}km`;
	}, [distance]);

	const tooltipText = React.useMemo(() => {
		return `Geographical distance from ${distanceFromText || "current property/location"}`;
	}, [distanceFromText]);

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span className="ml-auto text-xs bg-white/20 px-2 py-1 rounded-full cursor-help">{displayDistance}</span>
			</TooltipTrigger>
			<TooltipContent side="left">
				<p>{tooltipText}</p>
			</TooltipContent>
		</Tooltip>
	);
});
